/**
 * サイトヘッダー（A案）: メガメニュー / SPドロワー
 *
 * modely-renewal リポジトリ header-mock-0917 ブランチの _preview/js/header.js から
 * A案に要る部分だけを移植（B案のドロップダウン・縮小と、モック用の ?open= は外した）。
 *
 * マークアップ側の目印（template-parts/header/header-a.php）:
 *   [data-header]            ヘッダーの根。開いているあいだ .is-mega-open が付く
 *   a[data-mega="key"]       メガメニューを開くナビ項目
 *   [data-mega-panel="key"]  そのパネル（.is-open で表示）
 *   [data-mega-scrim]        背面の幕
 *   [data-drawer] / [data-drawer-open] / [data-drawer-close]
 */
export function initHeaderA() {
  const header = document.querySelector("[data-header]");
  if (!header) return;

  initMegaMenu(header);
  initDrawer(header);
}

function initMegaMenu(header) {
  const triggers = [...header.querySelectorAll("a[data-mega]")];
  const panels = new Map(
    [...header.querySelectorAll("[data-mega-panel]")].map((p) => [p.dataset.megaPanel, p]),
  );
  const scrim = document.querySelector("[data-mega-scrim]");
  const OPEN_DELAY = 80; // ナビの上を素通りしただけでは開かない
  const CLOSE_DELAY = 220; // ナビ→パネルへ斜めに動かしても閉じない
  let current = null;
  let timer = 0;

  const setOpen = (key) => {
    clearTimeout(timer);
    if (key === current) return;
    current = key;
    for (const t of triggers) t.setAttribute("aria-expanded", String(t.dataset.mega === key));
    for (const [k, p] of panels) p.classList.toggle("is-open", k === key);
    header.classList.toggle("is-mega-open", !!key);
    scrim?.classList.toggle("is-on", !!key);
  };
  const later = (key, ms) => {
    clearTimeout(timer);
    timer = setTimeout(() => setOpen(key), ms);
  };
  // ホバーで開くのはマウスだけ。タッチは1回目のタップで開き、2回目でリンク先へ進む
  const canHover = matchMedia("(hover: hover) and (pointer: fine)");

  for (const t of triggers) {
    const key = t.dataset.mega;
    t.addEventListener("mouseenter", () => canHover.matches && later(key, current ? 0 : OPEN_DELAY));
    t.addEventListener("mouseleave", () => canHover.matches && later(null, CLOSE_DELAY));
    t.addEventListener("click", (e) => {
      if (current === key) return; // 開いている状態のクリックは通常のリンク
      e.preventDefault();
      setOpen(key);
    });
    t.addEventListener("keydown", (e) => {
      if (e.key !== "ArrowDown" && e.key !== " ") return;
      e.preventDefault();
      setOpen(key);
      panels.get(key)?.querySelector("a")?.focus();
    });
  }
  for (const p of panels.values()) {
    p.addEventListener("mouseenter", () => clearTimeout(timer));
    p.addEventListener("mouseleave", () => canHover.matches && later(null, CLOSE_DELAY));
  }
  // メガメニューを持たないナビ項目に移ったらすぐ閉じる
  header.addEventListener("mouseover", (e) => {
    const a = e.target.closest("a, button");
    if (current && a && !a.dataset.mega && !a.closest("[data-mega-panel]")) later(null, 0);
  });
  scrim?.addEventListener("click", () => setOpen(null));
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || !current) return;
    const t = triggers.find((x) => x.dataset.mega === current);
    setOpen(null);
    t?.focus();
  });
  // Tab でヘッダーの外へ出たら閉じる
  header.addEventListener("focusout", (e) => {
    if (current && e.relatedTarget && !header.contains(e.relatedTarget)) setOpen(null);
  });
}

function initDrawer(header) {
  const drawer = document.querySelector("[data-drawer]");
  const opener = header.querySelector("[data-drawer-open]");
  if (!drawer || !opener) return;

  const open = () => {
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add("is-open"));
    document.body.style.overflow = "hidden";
    opener.setAttribute("aria-expanded", "true");
    drawer.querySelector("[data-drawer-close]")?.focus();
  };
  const close = () => {
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
    opener.setAttribute("aria-expanded", "false");
    setTimeout(() => {
      if (!drawer.classList.contains("is-open")) drawer.hidden = true;
    }, 200);
    opener.focus();
  };
  opener.addEventListener("click", open);
  drawer.querySelector("[data-drawer-close]")?.addEventListener("click", close);
  drawer.addEventListener("keydown", (e) => e.key === "Escape" && close());
  // ページ内リンク（#top など）を踏んだら閉じる
  drawer.addEventListener("click", (e) => e.target.closest('a[href^="#"]') && close());
}
